export default "__VITE_ASSET__DTV1rV73__"